import clsx from "clsx";
import { Icon } from "../icons";
import { useTranslation } from "../localization";
import type { FileUploadController } from "./use-file-upload";

/** Props Interface */
interface FileUploadStatusPendingProps {
	controller: FileUploadController;
}

export function FileUploadStatusUploading({ controller }: FileUploadStatusPendingProps) {
	/** Hooks */
	const { t } = useTranslation();

	if (!controller.isUploading && !controller.isUploaded) return null;
	if (controller.isFetchingDefaultFiles) return null;

	/** Render */
	return (
		<div className={clsx("flex flex-col flex-center gap-2")}>
			<Icon
				name="CloudUpload"
				className={clsx(
					"dropzone-icon",
					"stroke-emerald-500 text-2xl transition-all animate-pulse",
				)}
				size={18}
			/>
			<p className={clsx("text-primaryGray-500 text-xs")}>{t("file_upload.uploading")}...</p>
		</div>
	);
}
